import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { CHANNELS_ACTION_TYPE } from '../actions';

const initialState = {};

const channelsReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case CHANNELS_ACTION_TYPE.GET_CHANNELS:
        return payload;

      case CHANNELS_ACTION_TYPE.DELETE_CHANNEL:
        delete draft[meta.channelId];
        break;

      case CHANNELS_ACTION_TYPE.EDIT_CHANNEL:
      case CHANNELS_ACTION_TYPE.CREATE_CHANNEL:
        draft[payload.channelId] = payload;
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default channelsReducer;
